import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { Mail, Phone, MapPin } from "lucide-react";
import { companyInfo, navLinks } from "../mock";

const Footer = () => {
  return (
    <footer className="bg-brand-950 text-brand-200">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Logo variant="light" className="h-20" />
            <p className="mt-5 text-brand-300 leading-relaxed max-w-md text-[14px]">
              Persönliche und zuverlässige WEG-Verwaltung für Eigentümergemeinschaften am
              Niederrhein. Transparent, kompetent und persönlich erreichbar.
            </p>
            <div className="mt-6 text-[12px] text-brand-400">{companyInfo.legal}</div>
          </div>

          <div>
            <div className="font-display font-semibold text-white mb-4">Navigation</div>
            <ul className="space-y-2 text-[14px]">
              {navLinks.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="hover:text-white transition-colors">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-display font-semibold text-white mb-4">Kontakt</div>
            <ul className="space-y-3 text-[14px]">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-accent2" />
                <span>
                  {companyInfo.address.street}
                  <br />
                  {companyInfo.address.zip} {companyInfo.address.city}
                </span>
              </li>
              <li>
                <a
                  href={`tel:${companyInfo.phone.replace(/\s/g, "")}`}
                  className="flex items-center gap-3 hover:text-white transition-colors"
                >
                  <Phone className="w-4 h-4 text-accent2" />
                  {companyInfo.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${companyInfo.email}`}
                  className="flex items-center gap-3 hover:text-white transition-colors"
                >
                  <Mail className="w-4 h-4 text-accent2" />
                  {companyInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-[12px] text-brand-400">
          <div>© {new Date().getFullYear()} HTS Janzen Hausverwaltung. Alle Rechte vorbehalten.</div>
          <div className="flex gap-6">
            <Link to="/impressum" className="hover:text-white transition-colors" data-testid="footer-impressum-link">
              Impressum
            </Link>
            <Link to="/datenschutz" className="hover:text-white transition-colors" data-testid="footer-datenschutz-link">
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
